var exports = {
  "sJ": "xdbfd91f1--441362--grey_text",
  "dG": "xdbfd91f1--441362--villages_link",
  "wL": "xdbfd91f1--441362--villages_count",
};

module.exports = exports;
